import React from 'react'
import { Button } from '@/components/ui/button'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import type { ErrorFallbackProps } from '@/types'
import type { JSX } from 'react/jsx-runtime'

export const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps): JSX.Element => {
  React.useEffect(() => {
    if (import.meta.env.DEV) {
      console.error('Error Boundary caught an error:', error)
    }
  }, [error])

  return (
    <div className="flex min-h-[400px] items-center justify-center p-4">
      <div className="max-w-md space-y-4 text-center">
        <div className="flex justify-center">
          <AlertTriangle className="size-12 text-destructive" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">
            Something went wrong
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            We encountered an unexpected error. Please try refreshing the page.
          </p>
          {import.meta.env.DEV && (
            <details className="mt-4 text-left">
              <summary className="cursor-pointer text-sm font-medium">
                Error Details (Development)
              </summary>
              <pre className="
                mt-2 overflow-auto rounded-sm bg-muted p-2 text-xs
              ">
                {error.message}
              </pre>
            </details>
          )}
        </div>
        <div className="flex justify-center gap-2">
          <Button
            variant="outline"
            size="sm"
            className="flex items-center gap-2"
            onClick={resetErrorBoundary}
          >
            <RefreshCw className="size-4" />
            Try Again
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={() => {
              window.location.reload()
            }}
          >
            Refresh Page
          </Button>
        </div>
      </div>
    </div>
  )
}
